
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      UserRoles: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchUserRoles: null,
      UserRolesSearchMode: false,
      searchModel: "",
      state: state,
      user_roles_permissions:[]
    };
  },
  methods: {
    addUserRoles() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addUserRoles",
        inputs: [
          { model: "uid", type: "text", label: "user_roles.uid" },
          {
            model: "role_id",
            type: "select",
            options: (() => {
              return this.user_roles_permissions.map((data) => {
                return {
                  value: data.id,
                  label: data?.full_name,
                };
              });
            })(),
            label: "inventory_logs.driver_id",
          },
          { model: "created_at", type: "text", label: "user_roles.created_at" },
          { model: "updated_at", type: "text", label: "user_roles.updated_at" },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("user-roles", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editUserRoles(app) {
      var data = {
        title: "popups.user_roles",
        inputs: [
          {
            model: "uid",
            type: "text",
            label: "user_roles.uid",
            value: app.uid,
          },
          {
            model: "role_id",
            type: "text",
            label: "user_roles.role_id",
            value: app.role_id,
          },
          {
            model: "created_at",
            type: "text",
            label: "user_roles.created_at",
            value: app.created_at,
          },
          {
            model: "updated_at",
            type: "text",
            label: "user_roles.updated_at",
            value: app.updated_at,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("user-roles", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateUserRoles(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
          { model: "uid", type: "text", label: "user_roles.uid" },
          { model: "role_id", type: "text", label: "user_roles.role_id" },
          { model: "created_at", type: "text", label: "user_roles.created_at" },
          { model: "updated_at", type: "text", label: "user_roles.updated_at" },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("user-roles", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.UserRolesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("user-roles/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.UserRoles = res.data;
          console.log("######## files", this.UserRoles);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.UserRolesSearchMode = false;
      this.get(this.page);
    },

    getUserRoles() {
      this.http.get("user-roles").then((res) => {
        this.UserRoles = res.data;
      });
    },
    deleteUserRoles(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("user-roles", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("user-roles/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.UserRoles = res.data;
        });
    },
  },
  created() {
    this.get(1);
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.user_roles.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="UserRolesSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addUserRoles()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">{{ $t("user_roles.id") }}</th>
          <th scope="col">{{ $t("user_roles.uid") }}</th>
          <th scope="col">{{ $t("user_roles.role_id") }}</th>
          <th scope="col">{{ $t("user_roles.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app, index) in UserRoles" :key="app" class="text-center">
          <td>{{ index + 1 }}</td>
          <td>{{ app?.uid }}</td>
          <td>{{ app?.role_id }}</td>
          <td colspan="2">
            <a
              class="btn btn-primary mx-1"
              @click="editUserRoles(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteUserRoles(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




